export class OrganisationOrganisationTypeModel {
    public organisationOrganisationTypeId: string;
    public organisationId: string;
    public organisationTypeCode: string;
} 